import { InjectionToken, makeStateKey } from '@angular/core';

import { AppConfig } from '../app-config.types';

export const APP_ID = 'ng-front';

export const APP_CONFIG_KEY_IN_TRANSFER_STATE = makeStateKey<AppConfig>('app.config');

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');

export const BACK_API_URL = new InjectionToken<string>('BACK_API_URL');

export const BYTES_ATTACHMENT_MAX_SIZE = new InjectionToken<number>('BYTES_ATTACHMENT_MAX_SIZE');
export const BYTES_LIST_ATTACHMENT_MAX_SIZE = new InjectionToken<number>('BYTES_LIST_ATTACHMENT_MAX_SIZE');
export const DEFAULT_INIT_PAYLOAD_TOKEN = new InjectionToken<number>('DEFAULT_INIT_PAYLOAD_TOKEN');

export const READ_UNREAD_BEGIN_DATE = new InjectionToken<number>('READ_UNREAD_BEGIN_DATE');
export const ENABLE_VOCAL_MESSAGE = new InjectionToken<boolean>('ENABLE_VOCAL_MESSAGE');
